import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Modal from "react-modal";
import axios from "axios";
import { BASE_URL } from "../services/constant";
import { fetchContentPublications, fetchContentConfig } from "../services/apiContent";

import "./VideoConfig.scss";

Modal.setAppElement("#root");


const rowsPerPage = 10;

const VideoConfig = () => {
  const [events, setEvents] = useState([]);
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const [message, setMessage] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [page, setPage] = useState(1);
  const [currentTab, setCurrentTab] = useState(1); // 1 = non publié, 2 = publié
  const [savingIds, setSavingIds] = useState({});
  const [isDefault, setIsDefault] = useState(false);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  
  const categorieLabel = (value) =>
  value === 1 ? "Configurer" : value === 2 ? "Retirer" : "Configurer";



  const [form, setForm] = useState({
    id: null,
    date: "",
    date_end: "",
    start: "",
    end: "",
    is_default: false,
  });

  /* ---------------- LOAD DATA ---------------- */

  
  
    
    useEffect(() => {
      setFiltered(
        videos.filter((v) =>
          v.title.toLowerCase().includes(search.toLowerCase())
        )
      );
    }, [search, videos]);

  useEffect(() => {
    loadCalendar();
    
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;

    if(currentTab === 2) loadCalendarByMonth(year, month);
  }, []);

  const loadCalendar = async () => {
    const res = await axios.get(`${BASE_URL}api/video-schedule`);
    setEvents(res.data);
  };
  /*
  const loadVideos = async () => {
    const res = await axios.get(`${BASE_URL}api/contents/publications/2`);
    setVideos(res.data.data);
  }; */

  const loadCalendarByMonth = async (year, month) => {
    const res = await axios.get(
      `${BASE_URL}api/video-schedule/month`,
      {
        params: { year, month }
      }
    );
  
    const calendarEvents = res.data.map((s) => ({
      id: s.id,
      title: s.title,
      start: s.start_datetime,
      end: s.end_datetime,
      description: s.description,
      image: s.image,
      duration: s.duration,
      nom: s.nom,
      user_id: s.user_id,
      is_default: s.is_default,
      title_categorie: s.title_categorie,
      extendedProps: {
        video_id: s.video_id,
        is_default: s.is_default,
      },
    }));
    
    
    setVideos(calendarEvents);
    //setEvents(calendarEvents);
  };
  

  /* =======================
     Charger vidéos publiées
     ======================= */
     useEffect(() => {
      async function loadVideos() {
            const data = await fetchContentPublications(2); 
           if(currentTab === 1 ||  currentTab === null) setVideos(data || []);
      }
      loadVideos();
    }, [currentTab]);
  /* ---------------- MODAL ---------------- */

  const openModal = (video) => {
    setSelectedVideo(video);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setForm({ date: "", date_end: "", start: "", end: "", is_default: false });
  };

  /* ---------------- SAVE ---------------- */

  const saveSchedule = async () => {
    try {
      let start_datetime;
      let end_datetime;
      let is_default;
      
        start_datetime = `${form.date} ${form.start}`;
        end_datetime = `${form.date_end} ${form.end}`;
        is_default=form.is_default;
        // ⚠️ Vérification chevauchement UNIQUEMENT ici
        const check = await axios.post(
          `${BASE_URL}api/video-schedule/check-overlap`,
          {
            start_datetime,
            end_datetime,
            is_default,
          }
        );

        if (is_default=== 1 && check.data.overlap > 0) {
          alert("⚠️ Une vidéo est déjà programmée sur cette période !");
          return;
        }
  
      // ✏️ UPDATE
      if (form.id) {

        const modif =await axios.put(`${BASE_URL}api/video-schedule/${form.id}`, {
          start_datetime,
          end_datetime,
          is_default: form.is_default,
        });
        alert(modif.data.message);
        //console.log("response  ", modif.data);
      }
      // ➕ CREATE
      else {
        //console.log("data chexk ", check.data.overlap);
  
        await axios.post(`${BASE_URL}api/video-schedule`, {
          video_id: selectedVideo.id,
          start_datetime,
          end_datetime,
          is_default: form.is_default,
        });
        
        alert("⚠️ Video configuré avec success !");
      }
  
      closeModal();
      loadCalendar();
    } catch (err) {
      console.error(err);
      alert("❌ Erreur lors de l’enregistrement");
    }
  };
  
  const deleteSchedule = async (video) => {
    const confirm = window.confirm(
      "🗑️ Voulez-vous vraiment supprimer cette programmation ?"
    );
  
    if (!confirm) return;
  
    try {
      await axios.delete(
        `${BASE_URL}api/video-schedule/${video.id}`
      );
  
      loadCalendar(); // 🔄 refresh calendrier
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
  
      loadCalendarByMonth(year, month);
    } catch (err) {
      console.error(err);
      alert("❌ Erreur lors de la suppression");
    }
  };
  

  
  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const displayed = filtered.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

    // Limiter la description
function limitText(text, max = 250) {
  if (!text) return "";
  return text.length > max ? text.substring(0, max) + "..." : text;
}


// Formater date MySQL → "26 Aug 2022"
function formatDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}
function formatDateWithHour(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  });
}

// Convertir durée (secondes → HH:MM:SS)
function formatDuration(seconds) {
  if (!seconds || isNaN(seconds)) return "00:00";

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  // si 0 heure : n'afficher que mm:ss
  if (h === 0) {
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }

  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(
    s
  ).padStart(2, "0")}`;
}

const event = events.map(s => ({
  id: s.id,
  title: s.title,
  start: s.start,
  end: s.end,
  backgroundColor: s.conflict ? "#e74c3c" : s.is_default ? "#2ecc71" : "#3498db",
  extendedProps: {
    video_id: s.video_id,
    title: s.title,
    date: s.date,
    start: s.start,
    end: s.end,
    is_default: s.is_default
  }
}));
const statusLabel = (value) =>
value === 1 ? "Par defaut" : "Normale";


  /* ---------------- UI ---------------- */

  return (
    <div className="page-content">
      <div className="video-list-container">
        <h1>📺 Configuration de diffusion</h1>

      
          {/* Tabs */}
          <div className="tabs">
            <button
              className={`tab ${currentTab === 1 ? "active" : ""}`}
              onClick={() => setCurrentTab(1)}
            >
              Videos publiés
            </button>

            <button
              className={`tab ${currentTab === 2 ? "active" : ""}`}
              onClick={() => setCurrentTab(2)}
            >
              Videos configurés
            </button>
          </div>
          {currentTab === 1 && (
            <div className="section-left">
              {/* Search / Filter */}
              <div className="filter-bar">
                  <input
                    type="text"
                    placeholder="Filter videos..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
              </div>

              
              {/* TABLE VIDEOS */}
              <div className="vc-card">
                <table className="vc-table video-table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Video</th>
                      <th>Catégorie</th>
                      <th>Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                  {displayed.map((v) => (
                      <tr key={v.id}>
                          <td>
                              <input type="checkbox" />
                          </td>
                          <td className="video-cell">
                              <div className="thumb">
                              <img src={`${BASE_URL}api/${v.image}`} alt={v.id} />
                              <span className="duration">{formatDuration(v.duration)}</span>
                              </div>
                              <div className="video-info">
                                  <strong>{v.title}</strong>
                                  <p>{limitText(v.description, 50)}</p>
                                  <p className="acteur">Acteur : { v.nom}</p>
                              </div>
                          </td>
                          <td>{v.title_categorie}</td>
                          <td>{formatDate(v.created_at)}</td>
                        <td>
                          <button
                            className={`   ${ currentTab === 1 ? "vc-btn" : currentTab ===2 ? "vc-btn-2" : "vc-btn"}`}
                            onClick={() => {
                              setSelectedVideo(v);
                              setShowModal(v)
                              setShowModal(true);
                            }}
                          >
                            ⚙️ {categorieLabel(currentTab)}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Pagination */}
              <div className="pagination">
                <span>
                  Rows per page: <b>{rowsPerPage}</b>
                </span>
                <span>
                  {page} – {Math.ceil(filtered.length / rowsPerPage)} of{" "}
                  {filtered.length}
                </span>
                <button
                  disabled={page === 1}
                  onClick={() => handleChangePage(page - 1)}
                >
                  ‹
                </button>
                <button
                  disabled={page * rowsPerPage >= filtered.length}
                  onClick={() => handleChangePage(page + 1)}
                >
                  ›
                </button>
              </div>

            </div>
          )}
          {currentTab === 2 && (
            <div className="section-right">
              {/* CALENDRIER */}
              <FullCalendar
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                events={event}
                
                  datesSet={(info) => {
                    const date = info.view.currentStart; // début de la vue
                    const year = date.getFullYear();
                    const month = date.getMonth() + 1;

                    loadCalendarByMonth(year, month);
                  }}
                headerToolbar={{
                  left: "prev,next today",
                  center: "title",
                  right: "dayGridMonth,timeGridWeek",
                }}
                height={650}
              
                eventClick={(info) => {
                  const e = info.event;
              
                  // remplir le formulaire
                  setSelectedVideo({
                    id: e.extendedProps.video_id,
                    title: e.extendedProps.title
                  });
              
                  const toTime = (d) =>
                  d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });

                  setForm({
                    id: e.id,
                    date: e.start.toISOString().split("T")[0],
                    date_end: e.end.toISOString().split("T")[0],
                    start: toTime(e.start),
                    end: toTime(e.end),
                    is_default: e.extendedProps.is_default
                  });
              
                  setShowModal(true);
                }}
              />
              {/* LISTE VIDEOS */}
              <h2 style={{ marginTop: 40 }}>🎞 Vidéos configurés</h2>

              
              {/* Search / Filter */}
              <div className="filter-bar">
                  <input
                    type="text"
                    placeholder="Filter videos..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
              </div>

              
              {/* TABLE VIDEOS */}
              <div className="vc-card">
                <table className="vc-table video-table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Video</th>
                      <th>Catégorie</th>
                      <th>Date Debut</th>
                      <th>Date Fin</th>
                      <th>Statut</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                  {displayed.map((v) => (
                      <tr key={v.id}>
                          <td>
                              <input type="checkbox" />
                          </td>
                          <td className="video-cell">
                              <div className="thumb">
                              <img src={`${BASE_URL}api/${v.image}`} alt={v.id} />
                              <span className="duration">{formatDuration(v.duration)}</span>
                              </div>
                              <div className="video-info">
                                  <strong>{v.title}</strong>
                                  <p>{limitText(v.description, 50)}</p>
                                  <p className="acteur">Acteur : { v.nom}</p>
                              </div>
                          </td>
                          <td>{v.title_categorie}</td>
                          <td>{formatDateWithHour(v.start)}</td>
                          <td>{formatDateWithHour(v.end)}</td>
                          <td>{statusLabel(v.is_default)} </td>
                        <td>
                          <button
                            className={`   ${ currentTab === 1 ? "vc-btn" : currentTab ===2 ? "vc-btn-2" : "vc-btn"}`}
                            onClick={() => {
                              if (currentTab === 2) {
                                deleteSchedule(v); // 🗑️ suppression directe
                              } else {
                                setSelectedVideo(v);      // ⚙️ configurer
                                setShowModal(v)
                                setShowModal(true);
                              }
                            }}
                          >
                            ⚙️ {categorieLabel(currentTab)}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Pagination */}
              <div className="pagination">
                <span>
                  Rows per page: <b>{rowsPerPage}</b>
                </span>
                <span>
                  {page} – {Math.ceil(filtered.length / rowsPerPage)} of{" "}
                  {filtered.length}
                </span>
                <button
                  disabled={page === 1}
                  onClick={() => handleChangePage(page - 1)}
                >
                  ‹
                </button>
                <button
                  disabled={page * rowsPerPage >= filtered.length}
                  onClick={() => handleChangePage(page + 1)}
                >
                  ›
                </button>
              </div>


            </div>
          )}





      {/* MODAL CONFIG */}
      <Modal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        className="modal"
        overlayClassName="overlay"
      >
        <h2>📅 Programmer : {selectedVideo?.title}</h2>
        
        <div className="vc-time">
          <label>Date</label>
          <input
            type="date"
            value={form.date}
            onChange={(e) => setForm({ ...form, date: e.target.value })}
          />

          <label>Heure début</label>
          <input
            type="time"
            value={form.start}
            onChange={(e) => setForm({ ...form, start: e.target.value })}
          />

          <label>Heure fin</label>
          <input
            type="time"
            value={form.end}
            onChange={(e) => setForm({ ...form, end: e.target.value })}
          />

        </div>

        <label>
          <input
            type="checkbox"
            checked={form.is_default}
            onChange={(e) =>
              setForm({ ...form, is_default: e.target.checked })
            }
          />
          Vidéo par défaut
        </label>

        <div className="modal-actions">
          <button onClick={saveSchedule}>💾 Enregistrer</button>
          <button onClick={closeModal}>Annuler</button>
        </div>
      </Modal>


        {/* MODAL */}
        {showModal && selectedVideo && (
          
          <div className="vc-modal-overlay">
            <div className="vc-modal vc-modal-lg">
              <button
                className="vc-modal-close"
                onClick={() => setShowModal(false)}
              >
                ✕
              </button>

              <h2 className="vc-modal-title">
                📅 Programmer la diffusion
              </h2>

              <p className="vc-modal-subtitle">
                {selectedVideo.title}
              </p>

              <div className="vc-form">
              <hr className="vc-divider" />
                

              {/* CHECKBOX */}
              <div className="vc-form-checkbox">
                <input
                  type="checkbox"
                  checked={form.is_default}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      is_default: e.target.checked,
                    })
                  }
                />
                <span>Définir comme vidéo par défaut</span>
              </div>
              <hr className="vc-divider" />

                {/* DATE DE DÉBUT */}
                <div className="vc-form-group">
                  <label>Date de début</label>
                  <input
                    type="date"
                    value={form.date}
                    onChange={(e) =>
                      setForm({ ...form, date: e.target.value })
                    }
                  />
                </div>
                <div className="vc-form-group">
                  <label>Date de fin</label>
                  <input
                    type="date"
                    value={form.date_end}
                    onChange={(e) =>
                      setForm({ ...form, date_end: e.target.value })
                    }
                  />
                </div>

                {/* HEURES — seulement si PAS vidéo par défaut */}
                <div className="vc-form-row">
                  <div className="vc-form-group">
                    <label>Heure début</label>
                    <input
                      type="time"
                      value={form.start}
                      onChange={(e) =>
                        setForm({ ...form, start: e.target.value })
                      }
                    />
                  </div>

                  <div className="vc-form-group">
                    <label>Heure fin</label>
                    <input
                      type="time"
                      value={form.end}
                      onChange={(e) =>
                        setForm({ ...form, end: e.target.value })
                      }
                    />
                  </div>
                </div>
              <hr className="vc-divider" />
              
                {/* ACTIONS */}
                <div className="vc-modal-actions">
                  <button className="vc-btn primary" onClick={saveSchedule}>
                    💾 Enregistrer
                  </button>
                  <button className="vc-btn secondary" onClick={closeModal}>
                    Annuler
                  </button>
                </div>

              </div>
            </div>
          </div>

        )}


    </div>
    </div>
  );
};

export default VideoConfig;
